const listaDeTemplates = (state) => state.items
const loadingTemplates = (state) => state.carregando
const salvandoTemplate = (state) => state.salvando
const templateSelecionado = (state) => state.selecionado
const paginacao = (state) => state.paginacao
const filtros = (state) => state.filtros

export {
  listaDeTemplates,
  loadingTemplates,
  salvandoTemplate,
  templateSelecionado,
  paginacao,
  filtros
}
